<template>
	<div class="content">
		<section
			id="hero"
			class="container-expanded container band"
		>
			<h1>The Better Boys Blueprint</h1>
			<h2>Live masterclass with Adam Voigt - exclusive to Real School Partners!</h2>
			<h4>Wednesday 11 March 2026<br />2.00pm - 3.30pm AEDT</h4>
		</section>

		<section
			id="intro"
			class="container-expanded container cols band"
		>
			<div class="col col-2" />
			<div class="col col-center text-center">
				<h3>Our boys can’t wait – and neither can you.</h3>
				<p><strong>In this live masterclass, exclusive to Real Schools partner schools, Adam Voigt will help you Design a clear, practical plan to help boys thrive – emotionally, relationally and academically.</strong></p>
				<p>Boys are struggling… and the old rulebook doesn’t work anymore.</p>
				<p>Too many schools are stuck reacting to behaviour instead of proactively growing boys into the kind of men the world needs.</p>
				<p>And the cost isn’t just disengagement or behaviour issues. It’s far deeper – and far more dangerous.</p>
				<p>As Professor Scott Galloway warns, we’re growing a generation of lonely, disconnected, relationship-starved young men.</p>
				<p>Men who retreat instead of connect.</p>
				<p>Who turn to porn, online extremism or resentment when they can’t relate.</p>
				<p>And eventually, some become a danger to themselves or others.</p>
				<p>This isn’t alarmist. It’s already happening.</p>
				<p><strong>The problem?</strong> Most school systems are still punishing boys or protecting them from discomfort, instead of teaching them how to stay in community when they mess up.</p>
				<p>But there is a better way.</p>
				<p>One that’s clear, compassionate, and already working in schools just like yours.</p>
				<p>In this 60-minute workshop, we’ll go through a practical school-wide strategy to grow better boys – without relying on outdated discipline or soft, symbolic programs.</p>
				<p>You’ll map your current approach, spot the gaps, and leave with a plan that actually works across classrooms, corridors and community.</p>
				<p><strong>Spots are limited – and this matters too much to miss. </strong></p>
				<p><i>Adam Voigt’s Better Boys Blueprint Masterclass for Partners kicks off in…</i></p>

				<h3 class="text-center countdown">
					<CountdownComponent :target-epoch="masterclassTimestamp" />
				</h3>
				<div class="text-center">
					<a
						href="#register"
						class="btn btn-primary"
						>Register Now</a
					>
				</div>
			</div>
			<div class="col col-2" />
		</section>

		<section
			id="facilitators"
			class="cols container-expanded container-no-pad"
		>
			<div
				id="adam"
				class="col col-6"
			>
				<div class="col-inner">
					<h3>The blueprint needed for boys to thrive</h3>
					<p><strong>Here’s what we’ll cover in the workshop:</strong></p>

					<p>
						<strong>The Better Boys Blueprint</strong><br />
						A clear, school-wide strategy to grow boys who are connected, compassionate, and capable of healthy relationships.
					</p>

					<p>
						<strong>Why ‘discipline’ isn’t working, and what to do instead</strong>
						A new model that creates accountability without disconnection.
					</p>

					<p>
						<strong>The Cultural Gap</strong>
						Why boys are falling behind socially and relationally (and what schools need to do about it before it’s too late).
					</p>

					<p>
						<strong>The One Line That Changes Everything </strong>
						How a simple language shift can reframe behaviour, build buy-in, and lower resistance.
					</p>

					<p>
						<strong>The Three Silent Skills Boys Need </strong>
						And why missing them leads to loneliness, resentment, or worse.
					</p>

					<p>
						<strong>How to Keep Boys in the Community </strong>
						The proven approach that stops isolation before it starts.
					</p>

					<p>
						<strong>What Suspension Data Really Tells Us </strong>
						And how to use it to transform – not just track – behaviour.
					</p>

					<p>
						<strong>The Online War for Boys’ Minds </strong>
						What Andrew Tate won’t tell them – and how schools can fill the vacuum before he does.
					</p>
				</div>
			</div>
			<div class="col col-6">
				<div class="col-inner">
					<h3>Plus the resources you need to make it happen</h3>
					<p><strong>Everyone who attends also gets these bonus resources to put the change into action:</strong></p>

					<p>
						<strong>Bonus 1: The Better Boys Map</strong>
						A map outlining the journey boys need to walk – with our guidance – to grow into the men the world needs. Print it, share it, lead from it.
					</p>

					<p>
						<strong>Bonus 2: The Better Boys Commandments</strong>
						Ten unshakable strategic priorities every school must adopt to build better boys – and the men they’ll become.
					</p>

					<p>
						<strong>Bonus 3: The Better Boys Suspension Guide</strong>
						How to maintain high expectations without harm. A new approach to behaviour that keeps boys connected, while still learning from their mistakes.
					</p>

					<p>
						<strong>Bonus 4: ‘Making The Case For Our Boys’ Staff Slide Deck</strong>
						Share it with your staff. Use it to build buy-in, align your leadership team, and start shifting culture immediately.
					</p>
				</div>
			</div>
		</section>

		<section
			id="to-know"
			class="container-expanded container band"
		>
			<div class="cols">
				<div class="col col-2" />
				<div class="col">
					<div class="text-center">
						<h3><strong>The Better Boys Blueprint Masterclass</strong></h3>
						<h5>A LIVE, hands-on workshop specifically for school leaders.</h5>
					</div>
					<p><strong>Date:</strong> Wednesday 11 March 2026</p>
					<p><strong>Time:</strong> 2.00 – 3.30pmm AEDT</p>
					<p><strong>Cost:</strong> No cost for Real Schools partner schools</p>
				</div>
				<div class="col col-2" />
			</div>
		</section>

		<section
			id="register"
			class="band"
		>
			<div class="cols">
				<div class="col col-1" />
				<div class="col text-center">
					<h2>Let’s do this</h2>
					<p><strong>Our boys can’t wait. And neither can you.</strong></p>
					<p>Join us and lead the change your school – and your students – need.</p>

					<HubspotFormComponent
						form-id="023af487-e09f-4da9-9e4a-a920183640fe"
						intro-text="Click below to register."
						toggle-key="hasSubmittedTheBetterBoysBlueprintForm"
					>
						<template #registered>
							<h3>You're registered!</h3>
							<p>We can't wait to see you in the masterclass.</p>
						</template>
					</HubspotFormComponent>
				</div>
				<div class="col col-1" />
			</div>
		</section>
	</div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import heroImage from '@/images/the-better-boys-blueprint.webp';
import { wrapBackgroundImageUrlToCss } from '@/helpers';
import CountdownComponent from '@/components/shared/CountdownComponent.vue';
import HubspotFormComponent from '@/components/shared/HubspotFormComponent.vue';

export default defineComponent({
	components: {
		CountdownComponent,
		HubspotFormComponent,
	},
	data() {
		return {
			masterclassTimestamp: new Date('2026-03-11T14:00:00+11:00').getTime(),
		};
	},
	computed: {
		heroimageurl() {
			return wrapBackgroundImageUrlToCss(heroImage);
		},
	},
});
</script>

<style scoped lang="scss">
.content {
	h1,
	h2,
	h3,
	h4 {
		font-family: var(--rs-typography-font-body);
	}
}

#hero {
	display: flex;
	flex-direction: column;
	justify-content: flex-end;
	margin: 0;
	/* stylelint-disable-next-line declaration-property-value-no-unknown */
	background-image: v-bind(heroimageurl);
	background-position: center top 24%;
	background-size: cover;
	background-repeat: no-repeat;
	min-height: 400px;

	h1 {
		margin: 0 0 5px 0;
		color: white;
		text-shadow: 2px 2px 6px #00000082;
	}

	h2 {
		margin: 0;
		color: white;
		text-shadow: 2px 2px 6px #00000082;
	}
}

#intro {
	background-color: rgb(var(--rs-color-brand-navy));
	color: white;

	h3 {
		color: rgb(var(--rs-color-brand-mustard));
	}

	.aspect-ratio-box {
		padding-top: calc(9 / 16 * 100%);
	}
}

#to-know {
	background-color: rgb(var(--rs-color-brand-mustard));

	h3 {
		margin-top: 0;
		margin-bottom: 0;
		color: rgb(var(--rs-color-brand-navy));
	}

	h5 {
		margin-top: 0;
		margin-bottom: 30px;
	}
}

#adam {
	background-color: #eaeef1;
}
</style>
